import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=0bf5ea00&scoped=true&"
import script from "./DocumentDetail.vue?vue&type=script&lang=ts&"
export * from "./DocumentDetail.vue?vue&type=script&lang=ts&"
import style1 from "./DocumentDetail.vue?vue&type=style&index=1&id=0bf5ea00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5ea00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VSkeletonLoader})
